import { prop, propOr } from 'ramda'
import React, { useEffect } from 'react'

import { useForm, useFormState } from '../../../../../packages/kiti/components/form/form/FormHandler'
import FieldSentence from './FieldSentence'
import { MAP_KEY_EVENT } from '../_shared/constants'

const RelativeSentence = () => {
  const { handleChangeIn } = useFormState()
  const form = useForm()
  const event = prop('event')(form)
  const entity = propOr({}, 'entity')(form)

  useEffect(() => {
    handleChangeIn(['configuration'], {
      ...(form?.configuration ?? {}),
      entity,
      moment: MAP_KEY_EVENT[event] ?? undefined,
      time: 'relative_moment' === event ? 0 : undefined
    })
  }, [event, entity])

  if (!event?.startsWith('relative_')) return false

  return <FieldSentence index={0} />
}

export default RelativeSentence
